import {merge} from 'rxjs';
import {useEffect, useState} from 'react';

import {ChatInput} from '@stripe-internal/conversations-ui';
import {Conversation} from '@stripe-internal/conversations-client';

import {attachmentsEnabled, inputEnabled} from '../lib/util/conversationUtils';

type Props = {
  conversation: Conversation;
};

export function AssistantInput({conversation}: Props) {
  const [showInput, setShowInput] = useState<boolean>(
    inputEnabled(conversation),
  );
  const [disableAttachments, setDisableAttachments] = useState<boolean>(
    !attachmentsEnabled(conversation),
  );

  useEffect(() => {
    const sub = merge(
      conversation.statusObservable(),
      conversation.contextObservable(),
    ).subscribe(() => {
      setShowInput(inputEnabled(conversation));
      setDisableAttachments(!attachmentsEnabled(conversation));
    });

    return () => sub.unsubscribe();
  }, [conversation]);

  return (
    <ChatInput
      conversation={conversation}
      attachmentsDisabled={disableAttachments}
      hidden={!showInput || !!conversation.context?.placeholderConversation}
    />
  );
}
